import { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Container, Card, Typography, Button, Tabs, Tab, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiTypography from "components/SuiTypography";

import useUserRoles from "hooks/useUserRoles";

import ContainerResumen from "./containerResumen";
import ContainerComunicaciones from "./containerComunicaciones";
import ContainerAudiencias from "./containerAudiencias";
import ProcesosApi from "api/procesosApi";

const ContainerProceso = () => {
  const { user, roles } = useUserRoles();
  const history = useHistory();
  const location = useLocation();
  const { identificador } = useParams();
  const [proceso, setProceso] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const queryParams = new URLSearchParams(location.search);
  const origen = queryParams.get("origen");

  const fetchProceso = async () => {
    const response = await ProcesosApi.fetchProcesoByIdentificador(identificador);
    setProceso(response.data);
  };
  useEffect(() => {
    fetchProceso();
  }, [user]);

  const handleProcesoChange = async () => {
    await fetchProceso();
  };

  const fetchDatosResumen = async () => {
    try {
      const respResumen = await ProcesosApi.obtenerResumenProceso(identificador);
      const data = respResumen.data;
      //alert(JSON.stringify(data));
      setProceso(data.proceso);
    } catch (error) {
      console.error("Error al obtener los datos del resumen:", error);
    }
  };

  const hasAdvancedPermissions = () => {
    return roles.isAdmin || roles.isOperador || roles.isCoordinador || roles.isDirector;
  };

  useEffect(() => {
    if (identificador) {
      fetchDatosResumen();
    }
  }, [identificador]);

  const handleChange = (event, newIndex) => {
    if (!hasAdvancedPermissions() && newIndex > 0) {
      alert("Usuario sin permisos para acceder a este Tab.");
      return;
    }
    setTabIndex(newIndex);
  };

  const handleVolver = () => {
    if (origen === "bandeja") {
      history.push(`/procesos/bandeja`);
    } else {
      history.push(`/procesos/consultar`);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "No tiene.";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Container
      maxWidth={false}
      disableGutters // Elimina los paddings laterales
      sx={{
        px: 0, // Asegura padding horizontal cero
        mx: 0, // Asegura margen horizontal cero
      }}
    >
      {proceso ? (
        <>
          <Grid
            container
            rowSpacing={0.5}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}
          >
            {/* Fila 1 */}
            <Grid item>
              <SuiTypography variant="h3" fontWeight="bold">
                {proceso.tipo_proceso_detalle.nombre || ""}
              </SuiTypography>
            </Grid>
            <Grid item>
              <SuiTypography variant="h5" fontWeight="bold">
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: proceso.autorizado ? "#43a047" : "#e53935",
                    color: "white",
                    padding: 0.2,
                    borderRadius: 2,
                    boxShadow: 4,
                    height: "100%",
                    minHeight: "50px",
                  }}
                >
                  <SuiTypography variant="subtitle1" fontWeight="bold">
                    {proceso.autorizado ? "Autorizado" : "No Autorizado"}
                  </SuiTypography>
                </Card>
              </SuiTypography>
            </Grid>
            <Grid item sx={{ gridRow: "span 2" }}>
              <Card
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor:
                    proceso.dias_habiles_restantes > 40
                      ? "#43a047" // Verde
                      : proceso.dias_habiles_restantes > 20
                      ? "#f39c12" // Naranja
                      : "#e53935", // Rojo
                  color: "white",
                  padding: 1,
                  borderRadius: 2,
                  boxShadow: 4,
                  height: "100%",
                }}
              >
                <Box sx={{ p: 0.1, textAlign: "center" }}>
                  <SuiTypography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1.7 }}>
                    Días Restantes: {proceso.dias_habiles_restantes}
                  </SuiTypography>
                  <SuiTypography
                    variant="caption"
                    fontWeight="bold"
                    sx={{ lineHeight: 1.5, display: "block" }}
                  >
                    Fecha Admisión: {formatDate(proceso.fecha_admision)}
                  </SuiTypography>
                  {proceso.prorrogas?.length > 0 && (
                    <Box sx={{ textAlign: "center" }}>
                      {proceso.prorrogas.map((prorroga, index) => (
                        <SuiTypography
                          key={index}
                          variant="caption"
                          sx={{
                            display: "block",
                            lineHeight: 1.2,
                            fontSize: "0.7rem",
                          }}
                        >
                          #{prorroga.orden}: +{prorroga.cantidad_dias}d (
                          {formatDate(prorroga.fecha_creacion)})
                        </SuiTypography>
                      ))}
                    </Box>
                  )}
                </Box>
              </Card>
            </Grid>
            {/* Fila 2 */}
            <Grid item>
              <SuiTypography variant="h3" fontWeight="light">
                {proceso.cliente_detalle.nombre_completo || ""}
                {" ("}
                {proceso.cliente_detalle.tipo_identificacion || ""} -{" "}
                {proceso.cliente_detalle.identificacion || ""}
                {")"}
              </SuiTypography>
            </Grid>
            <Grid item>
              <SuiTypography variant="h6" fontWeight="bold">
                Estado Proceso:{" "}
                <SuiTypography component="span">
                  {proceso.estado_detalle.nombre || ""}
                </SuiTypography>
                <br />
                Responsable:{" "}
                <SuiTypography component="span">
                  {proceso.responsable_detalle
                    ? proceso.responsable_detalle.usuario
                      ? proceso.responsable_detalle.usuario.nombre_completo
                      : proceso.responsable_detalle.grupo
                      ? "Grupo - " + proceso.responsable_detalle.grupo.name
                      : "No tiene."
                    : "No tiene."}
                </SuiTypography>
                <br />
                Finalidad: <SuiTypography component="span">{proceso.finalidad || ""}</SuiTypography>
              </SuiTypography>
            </Grid>
          </Grid>
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            variant="scrollable"
            textColor="inherit"
            sx={{
              mt: 1, // Margen superior de 16px (2 * tema.spacing)
              backgroundColor: "background.paper", // Opcional: fondo consistente
              borderRadius: "4px", // Opcional: bordes redondeados
              boxShadow: 1, // Opcional: ligera sombra para profundidad
            }}
            TabIndicatorProps={{
              style: { backgroundColor: "#1976d2" }, // Color del indicador
            }}
          >
            <Tab
              label="Resumen"
              sx={{
                color: tabIndex === 0 ? "white !important" : "inherit",
                backgroundColor: tabIndex === 0 ? "#1976d2" : "#e3f2fd",
                fontWeight: tabIndex === 0 ? "bold" : "normal",
                marginRight: "8px", // Espacio entre pestañas
                transition: "0.3s",
              }}
            />
            <Tab
              label="Comunicaciones"
              sx={{
                color: tabIndex === 1 ? "white !important" : "inherit",
                backgroundColor: tabIndex === 1 ? "#1976d2" : "#e3f2fd",
                fontWeight: tabIndex === 1 ? "bold" : "normal",
                marginRight: "8px", // Espacio entre pestañas
                transition: "0.3s",
              }}
            />
            <Tab
              label="Audiencias"
              sx={{
                color: tabIndex === 2 ? "white !important" : "inherit",
                backgroundColor: tabIndex === 2 ? "#1976d2" : "#e3f2fd",
                fontWeight: tabIndex === 2 ? "bold" : "normal",
                marginRight: "8px", // Espacio entre pestañas
                transition: "0.3s",
              }}
            />
          </Tabs>
          <Box sx={{ p: 1, border: "1px solid #ddd", borderRadius: "4px", mt: 1 }}>
            {tabIndex === 0 && <ContainerResumen proceso={proceso} />}
            {tabIndex === 1 && (
              <ContainerComunicaciones proceso={proceso} onProcesoChange={handleProcesoChange} />
            )}
            {tabIndex === 2 && (
              <ContainerAudiencias proceso={proceso} onProcesoChange={handleProcesoChange} />
            )}
          </Box>

          <Button variant="contained" color="transparent" onClick={handleVolver}>
            Volver
          </Button>
        </>
      ) : (
        <Typography>Cargando...</Typography>
      )}
    </Container>
  );
};

export default ContainerProceso;
